import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantReviewPage = {
  footer: {
    root: 'coapplicant-review-page.footer.root',
  },
  form: {
    h1: 'coapplicant-review-page.form.h1',
    h2: 'coapplicant-review-page.form.h2',
    root: 'coapplicant-review-page.form.root',
    submitButton: 'coapplicant-review-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
